import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceComparisonOnlyJoveCoverageListView = function PriceComparisonOnlyJoveCoverageListView(props) {
  var list = props.list,
      className = props.className;
  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col space-y-4', className),
    children: (list || []).map(function (item, index) {
      return /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "subtitle1",
          className: "text-black-secondary font-bold",
          children: item.title
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle1",
          className: "text-black-secondary font-medium",
          children: item.coverageText
        })]
      }, index);
    })
  });
};

export default PriceComparisonOnlyJoveCoverageListView;